import React from 'react'
import { Avatar, AvatarProps } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'

import { ASSETS_BASE_URL } from 'constants/apiConstants'

const DEFAULT_IMG_AVATAR = `${ASSETS_BASE_URL}/assets/images/placeholder-avatar.png`

export const useAgentAvatarStyles = makeStyles(theme => ({
	small: {
		height: theme.spacing(3),
		width: theme.spacing(3),
	},
	large: {
		height: theme.spacing(5),
	},
}))

const AgentAvatar = ({ src, ...rest }: AvatarProps) => <Avatar src={src ?? DEFAULT_IMG_AVATAR} alt="avatar" {...rest} />

export default AgentAvatar
